import React, { useRef, useState } from "react";
import { FaAngleDoubleDown } from "react-icons/fa";

export const Accordion = ({
  title,
  content,
  textColor,
  textSize,
  bgContentColor,
  bgTitleColor,
  drawDown,
}) => {
  const [isOpened, setOpened] = useState(false);
  const [height, setHeight] = useState("0px");
  const contentElement = useRef(null);

  const HandleOpening = () => {
    setOpened(!isOpened);
    setHeight(!isOpened ? `${contentElement.current.scrollHeight}px` : "0px");
  };

  return (
    <div 
      onClick={HandleOpening} 
      className="border border-gray-100 rounded-xl overflow-hidden mb-3 hover:shadow-soft-sm transition-all duration-300"
    >
      <div
        className={`${
          bgTitleColor ? bgTitleColor : "bg-white"
        } p-4 flex justify-between items-center cursor-pointer ${textColor ? textColor : "text-gray-800"}`}
      >
        <h4 className="font-semibold text-lg text-gray-900">
          {title}
        </h4>
        {drawDown && (
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-300 ${
            isOpened 
              ? "bg-gradient-to-r from-gray-900 to-gray-800 text-white rotate-180" 
              : "bg-gray-100 text-gray-600"
          }`}>
            <FaAngleDoubleDown className="text-sm" />
          </div>
        )}
      </div>
      <div
        ref={contentElement}
        style={{ height: height }}
        className={`${
          bgContentColor ? bgContentColor : "bg-gray-50"
        } overflow-hidden transition-all duration-300`}
      >
        <p className={`p-4 text-gray-600 ${textSize ? textSize : "text-base"}`}>
          {content}
        </p>
      </div>
    </div>
  );
};
